module.exports = __webpack_public_path__ + "img/90e3786.gif";